import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Icon, TimelineContainer, Typography } from '@drone-js/core';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import ItineraryStep, { SingleDayItineraryProps } from 'component/page/detail/Itineraries/StructuredItinerary/ItineraryStep';

export interface ItineraryStepperComponentProps {
    dayItinerary: SingleDayItineraryProps[];
    dayDescription: string;
    contentLocale: string;
}

export const ItineraryStepperComponent: React.FC<ItineraryStepperComponentProps> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);
    if (!props.dayItinerary || props.dayItinerary.length === 0) {
        return null;
    }

    return (
        <>
            {!!props.dayDescription && (
                <Box verticalAlign="sub">
                    <Icon id="fill.food.fork-knife" size="16" />
                    <Typography data-testid="itinerary-day-description" variant="body-s" tag="span" ms="8" lang={props.contentLocale}>
                        {cms[246412]} {props.dayDescription}
                    </Typography>
                </Box>
            )}

            <Box py="12" px="16" data-testid="detail-itinerary-singled">
                <TimelineContainer direction="vertical">
                    {props.dayItinerary.map(
                        (iti, i) =>
                            (!!iti.description || !!iti.title) && (
                                <ItineraryStep key={i} itinerary={iti} cms={cms} contentLocale={props.contentLocale} isLastStep={i === props.dayItinerary.length - 1} />
                            ),
                    )}
                </TimelineContainer>
            </Box>
        </>
    );
};
ItineraryStepperComponent.displayName = 'ItineraryStepperComponent';
